import React from "react";
import InvoicesPrint from "./InvoicesPrint";

export default function DefaultInv(props) {
    return (
        <div>
            <InvoicesPrint  typeInv={1} />
        </div>
    );
}
